/**
 * Decide whether a link should open in a new browser tab.
 *
 * "External" means an absolute http(s) URL whose origin differs from the app's
 * own origin. Everything else stays in the current tab:
 *   - relative links and in-page anchors (`#section`) — handled by the SPA
 *   - same-origin absolute URLs (e.g. a deep link back into the console) — so
 *     we don't bounce the user into a new tab for what is really internal nav
 *   - non-http schemes (`mailto:`, `tel:`) — let the OS handler take over
 *
 * Returns false during SSR / when there is no `window` to compare against.
 */
export function isExternalUrl(href: string | undefined | null): boolean {
  if (!href) return false;
  if (typeof window === 'undefined') return false;

  let url: URL;
  try {
    url = new URL(href, window.location.origin);
  } catch {
    return false;
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
  return url.origin !== window.location.origin;
}
